module.exports = __webpack_public_path__ + "c220a22cd42857f5941bd8b31b824a0b.png";